app.controller('crmController', function ($rootScope, $scope, $http, $location, $routeParams, safeApply, clientService, systemService) {
  $rootScope.footer_message = 'Copyright <sup>©</sup>2026. PropertyTax.io - All right reserved.'
  $rootScope.user_info = null

  const host = $location.$$host == 'localhost' ? "" : "https://api.propertytax.io"
  // const host = "https://api.propertytax.io"

  $scope.dashboardObj = {
    activePanel: "clients_edit",
    activePanelName: "Client Details",
    currentTime: "",
    dateTimeHTML: "",
  }

  if ($location.$$host == 'localhost') {
    // $scope.dashboardObj = {
    //   activePanel: "unsigned_docs",
    //   activePanelName: "Unsigned Documents",
    // }    
    // $scope.dashboardObj = {
    //   activePanel: "hearing_portal",
    //   activePanelName: "Hearing Portal",
    // }
    // $scope.dashboardObj = {
    //   activePanel: "accounting_receivables",
    //   activePanelName: "Accounts Receivables"
    // }
    // $scope.dashboardObj = {
    //   activePanel: "payments_received",
    //   activePanelName: "Payments Received"
    // }
    // $scope.dashboardObj = {
    //   activePanel: "accounting_manual_payment",
    //   activePanelName: "OLD MANUAL PAY"
    // }
    // $scope.dashboardObj = {
    //   activePanel: "accounting_manual_payment_v2",
    //   activePanelName: "Enter Manual Payments"
    // }
    $scope.dashboardObj = {
      activePanel: "usps_mailings",
      activePanelName: "USPS Mailings"
    }
    // $scope.dashboardObj = {
    //   activePanel: "report_viewer",
    //   activePanelName: "report_viewer"
    // }
    // $scope.dashboardObj = {
    //   activePanel: "clients_edit",
    //   activePanelName: "clients_edit"
    // }
  }

  /*
    Deep link: /{user_id}/{url_password}/{target_user_id} opens straight into the
    client record. Set here rather than in initCRMController() because the
    default panel is applied synchronously at the end of the navigation region,
    which runs before that async init resolves. clientController then loads the
    client itself via loadClientFromRouteParam().
    /{user_id}/{url_password}/prop/{prop_id} does the same for the client that owns
    the property, then opens only that property's card.
    /{user_id}/{url_password}/pid/{cad_code}/{cad_account} finds the property by CAD account.
  */
  if ($routeParams.target_user_id || $routeParams.prop_id || $routeParams.cad_account) {
    clientService.setClientMode('clients_edit')
    $scope.dashboardObj.activePanel = "clients_edit"
    $scope.dashboardObj.activePanelName = "Edit Client"
  }

  // $scope.tinymceOptions = {
  //   selector: 'textarea',
  //   plugins: 'link image code',
  //   toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code',
  //   height: "400",
  //   content_style: "body { line-height: 1; }",
  // }

  toastr.options = {
    "closeButton": true, "debug": false,
    "newestOnTop": true, "progressBar": true,
    "positionClass": "toast-bottom-right", "preventDuplicates": false,
    "onclick": null, "showDuration": "3000",
    "hideDuration": "2000", "extendedTimeOut": "2000",
    "showEasing": "swing", "hideMethod": "fadeOut",
    "hideEasing": "linear", "showMethod": "fadeIn"
  }

  // main.html renders nothing of the CRM until this is 'ok' - 'checking' shows a blank page,
  // 'denied' shows only the "Authorized ... employees" notice (no valid user_id / url_password in the URL).
  $scope.authState = 'checking'

  initCRMController()
  async function initCRMController() {
    // load user info from params
    if ($routeParams.user_id && $routeParams.url_password) {
      // get user info
      let verifyUserCredentialsResults = await systemService.functionCall(
        { type: "verifyUserCredentials", user_id: $routeParams.user_id, url_password: $routeParams.url_password }
      ).catch(() => null)
      if (verifyUserCredentialsResults && verifyUserCredentialsResults.data.success) {
        let taxYearResults = await systemService.functionCall({ type: "getCurrentTaxYear" })
        $rootScope.tax_year = taxYearResults.data.data
        $scope.user = verifyUserCredentialsResults.data.data
        $rootScope.user_info = $scope.user
        systemService.setUserObj($scope.user)
      } else {
        $scope.user = null
      }
    } else {
      $scope.user = null
    }

    if (!$scope.user) {
      $scope.authState = 'denied'
      safeApply($scope)
      return
    }
    $scope.authState = 'ok'

    let allCountiesResults = await systemService.functionCall({ type: "countyList", active_only: false })
    $scope.allCounties = allCountiesResults.data.data
    console.log('$scope.allCounties :>> ', $scope.allCounties)
    safeApply($scope)
  }

  //--------------------------------------------------------
  //#region - Misc Functions Area
  function castAsCurrency(value) {
    return Math.round((value + Number.EPSILON) * 100) / 100
  }
  //#endregion Misc Functions Area
  //--------------------------------------------------------

  //--------------------------------------------------------
  //#region - Navigation Area
  $scope.navChange = function (menu_item) {
    console.log('menu_item :>> ', menu_item);
    setTimeout(() => {
      $('.mm-active').removeClass('mm-active')
      $(`li.a__${menu_item}`).addClass('mm-active')
    }, 500)
    let url = ""
    switch (menu_item) {
      case 'email_editor':
        clientService.setClientMode('email_editor')
        $scope.dashboardObj.activePanelName = "Email Editor"
        break
      case 'sync_sendgrid_contacts':
        clientService.setClientMode('sync_sendgrid_contacts')
        $scope.dashboardObj.activePanelName = "Sync SendGrid Contacts"
        break
      case 'cad_sync':
        clientService.setClientMode('cad_sync')
        $scope.dashboardObj.activePanelName = "Upload CAD Portal Files"
        break
      case 'cad_sync_table':
        clientService.setClientMode('cad_sync_table')
        $scope.dashboardObj.activePanelName = "Manage Authorization and Hearing Dates"
        break
      // Sub Menu Items for CAD ISSUES-------------------------------------------------
      case 'cad_sync_table':
        clientService.setClientMode('cad_sync_table')
        $scope.dashboardObj.activePanelName = "Manage Authorization Issues"
        break
      case 'cad_sync_table_need_cancel':
        clientService.setClientMode('cad_sync_table_need_cancel')
        $scope.dashboardObj.activePanelName = "Properties to Cancel Service On"
        break
      case 'cad_sync_table_hearing_conflicts':
        clientService.setClientMode('cad_sync_table_hearing_conflicts')
        $scope.dashboardObj.activePanelName = "Hearing Date Conflicts"
        break
      // ----------------------------------------------------------------------------
      case 'county_list':
        clientService.setClientMode('county_list')
        $scope.dashboardObj.activePanelName = "County List"
        break
      case 'unsigned_docs':
        clientService.setClientMode('unsigned_docs')
        $scope.dashboardObj.activePanelName = "Unsigned Documents"
        break
      case 'downloadAOA':
        clientService.setClientMode('downloadAOA')
        $scope.dashboardObj.activePanelName = "Download AOA's"
        break

      case 'report_viewer':
        clientService.setClientMode('report_viewer')
        $scope.dashboardObj.activePanelName = "Report Viewer"
        break

      case 'accounting_receivables':
        clientService.setClientMode('accounting_receivables')
        $scope.dashboardObj.activePanelName = "Accounts Receivables"
        break
      case 'payments_received':
        clientService.setClientMode('payments_received')
        $scope.dashboardObj.activePanelName = "Payments Received"
        break
      case 'hearing_portal':
        clientService.setClientMode('hearing_portal')
        $scope.dashboardObj.activePanelName = "Case Management"
        break
      case 'accounting_manual_payment_v2':
        clientService.setClientMode('accounting_manual_payment_v2')
        $scope.dashboardObj.activePanelName = "Enter Manual Payments"
        break
      case 'accounting_manual_payment':
        clientService.setClientMode('accounting_manual_payment')
        $scope.dashboardObj.activePanelName = "OLD MANUAL PAY"
        break
      case 'appeal_cert_values':
        clientService.setClientMode('appeal_cert_values')
        $scope.dashboardObj.activePanelName = "Certified Values"
        break
      case 'gold_wizard_check':
        clientService.setClientMode('gold_wizard_check')
        $scope.dashboardObj.activePanelName = "GOLD Wizard Check"
        break
      case 'review_evidence':
        const url = `https://evidence.propertytax.io/review/reports/${$scope.user.id}/${$scope.user.url_password}/${$rootScope.tax_year}`
        window.open(url, '_blank')
        break
      case 'appeal_batches':
        clientService.setClientMode('appeal_batches')
        $scope.dashboardObj.activePanelName = "Appeal Batches"
        break
      case 'clients_add':
        clientService.setClientMode('clients_add')
        $scope.dashboardObj.activePanelName = "Add New Client"
        break
      case 'clients_edit':
        clientService.setClientMode('clients_edit')
        $scope.dashboardObj.activePanelName = "Client Details"
        break
      case 'download_invoices':
        clientService.setClientMode('download_invoices')
        $scope.dashboardObj.activePanelName = "Download Invoices"
        break
      case 'cancel_service':
        clientService.setClientMode('cancel_service')
        $scope.dashboardObj.activePanelName = "Cancel Service"
        break
      case 'dashboard_stats':
        clientService.setClientMode('dashboard_stats')
        $scope.dashboardObj.activePanelName = "Application Stats"
        break
      case 'usps_mailings':
        clientService.setClientMode('usps_mailings')
        $scope.dashboardObj.activePanelName = "USPS Mailings"
        break
      case 'email_creator':
        clientService.setClientMode('email_creator')
        $scope.dashboardObj.activePanelName = "Create Email"
        break
      case 'emails_received':
        clientService.setClientMode('emails_received')
        $scope.dashboardObj.activePanelName = "Emails Received"
        break

      case 'log_out':
        Swal.fire({
          title: 'Are you sure?',
          text: "You will need to Sign In again to access your Account!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Sign Out!'
        }).then((result) => {
          if (result.isConfirmed) {
            $scope.route('sign_in', null)
          }
        })
        return
        break
    }
    $scope.dashboardObj.activePanel = menu_item
    $(".wrapper").removeClass("toggled")
    $(".page-content-header").removeClass("menu-closed")
  }
  $scope.showPanel = function (panel_name) {
    if ($rootScope.initInProgress) return false
    return panel_name.toLowerCase() === $scope.dashboardObj.activePanel.toLowerCase()
  }
  $scope.navChange($scope.dashboardObj.activePanel)

  //#endregion Navigation Area
  //--------------------------------------------------------

  // Template Functions -----------------------------------------------------------------
  //#region - Template Functions
  $('html').attr('class', 'color-sidebar sidebarcolor3 color-header headercolor2')

  $scope.initHeaderMessageList = function () {
    new PerfectScrollbar('.header-message-list')
  }
  $scope.initHeaderNotificationsList = function () {
    new PerfectScrollbar('.header-notifications-list')
  }
  $scope.initMenu = function () {
    // toggle left-menu button
    $(".toggle-icon").on("click", function () {
      if ($(".wrapper").hasClass("toggled")) {
        $(".wrapper").removeClass("toggled")
        $(".sidebar-wrapper").unbind("hover")
        // $(".page-content-header").removeClass("menu-closed")
      } else {
        $(".wrapper").addClass("toggled")
        $(".sidebar-wrapper").hover(function () {
          $(".wrapper").addClass("sidebar-hovered")
          // $(".page-content-header").removeClass("menu-closed")
        }, function () {
          $(".wrapper").removeClass("sidebar-hovered")
          // $(".page-content-header").addClass("menu-closed")
        })
      }
      $(".page-content-header").removeClass("menu-closed")
      if ($(".wrapper").hasClass("toggled")) {
        $(".page-content-header").addClass("menu-closed")
      }
    })
    $(function () {
      for (var i = window.location, o = $(".metismenu li a").filter(function () {
        return this.href == i
      }).addClass("").parent().addClass("mm-active"); ;) {
        if (!o.is("li")) break
        o = o.parent("").addClass("mm-show").parent("").addClass("mm-active")
      }
    })
    $(function () { $('#menu').metisMenu() })
  }

  $scope.initHeader = function () {
    $(".mobile-search-icon").on("click", function () {
      $(".search-bar").addClass("full-search-bar")
      $(".page-wrapper").addClass("search-overlay")
    });
    $(".search-close").on("click", function () {
      $(".search-bar").removeClass("full-search-bar")
      $(".page-wrapper").removeClass("search-overlay")
    });
    $(".mobile-toggle-menu").on("click", function () {
      $(".wrapper").addClass("toggled")
    })
  }

  $(document).ready(function () {
    $(window).on("scroll", function () {
      if ($(this).scrollTop() > 300) {
        $('.back-to-top').fadeIn()
      } else {
        $('.back-to-top').fadeOut()
      }
    })
    $('.back-to-top').on("click", function () {
      $("html, body").animate({
        scrollTop: 0
      }, 200)
      return false
    })
  })

  //#endregion Navigation Area

})
